import React, { Component } from 'react';

import './sentence.scss';

const ConditionalField =
    ({ show, children }) => {
        return show ? children : null;
    };
export class Sentence extends Component {
    render() {
        const { sufix, prefix, dropdown, disabled, displayLogic, name } = this.props;
        return <ConditionalField show={displayLogic}>
            <div key={name} className={`nlsentence ${disabled ? 'nlsentence--disabled' : ''}`} >
                <span className='nlsentence-textwrap'>
                    <span className='nlsentence-text--prefix nlsentence-text'>{prefix}</span>
                    {dropdown}
                    <span className='nlsentence-text--suffix nlsentence-text'>{sufix}</span>
                </span>
            </div>
        </ConditionalField>;
    }
}
